import React from 'react';
import Navigation from './components/Navigation';
import SceneBackdrop from './components/backdrop/SceneBackdrop';
import HeroSection from './components/HeroSection';
import ProofBar from './components/ProofBar';
import DemoSection from './components/DemoSection';
import HowItWorksSection from './components/HowItWorksSection';
import AppShowcaseSection from './components/AppShowcaseSection';
import SignupSection from './components/SignupSection';
import StoresSection from './components/StoresSection';
import Footer from './components/Footer';

const App: React.FC = () => {
  return (
    <div className="min-h-screen">
      {/* Sits above the page ground but below every piece of content. */}
      <SceneBackdrop />

      <div className="relative z-10">
        <Navigation />
        <main>
          <HeroSection />
          <ProofBar />
          <DemoSection />
          <HowItWorksSection />
          <AppShowcaseSection />
          <SignupSection />
          <StoresSection />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default App;
